import * as i from 'io-ts';
import { ConfigurableProperties } from '@dora/backpack';
import * as S from '../summary';

const CommonGiftProduct = i.type({
    canonicalId: i.string,
    name: i.string,
    description: i.string,
    productType: i.string,
    availability: i.string,
    discontinued: i.boolean,
    price: i.type({
        value: i.number,
        currency: i.string,
        saleValue: i.union([i.undefined, i.number]),
    }),
    productUrl: i.string,
    thumbnailUrl: i.string,
    properties: i.record(i.string, i.unknown),
    features: i.array(i.string),
    leadTime: i.union([i.undefined, i.type({ description: i.string, priority: i.number })]),
});

type CommonGiftProduct = i.TypeOf<typeof CommonGiftProduct>;

const SimpleGiftProduct = i.intersection([
    CommonGiftProduct,
    i.type({
        kind: i.union([i.undefined, i.literal('simple')]),
        articles: i.record(
            i.string,
            i.partial({
                thumbnail: i.string,
            }),
        ),
        groupingCode: i.union([i.null, i.string]),
        configurableProperties: i.union([i.undefined, ConfigurableProperties.Gift]),
        properties: i.partial({
            rattan_colour: ConfigurableProperties.Finish,
            table_finish: ConfigurableProperties.Finish,
        }),
    }),
]);

type SimpleGiftProduct = i.TypeOf<typeof SimpleGiftProduct>;

const BundleGiftProduct = i.intersection([
    CommonGiftProduct,
    i.type({
        kind: i.literal('bundle'),
        products: i.array(i.string),
        properties: i.partial({ range: i.array(i.string) }),
    }),
]);

type BundleGiftProduct = i.TypeOf<typeof BundleGiftProduct>;

export const Product = i.union([SimpleGiftProduct, BundleGiftProduct]);
/**  A product as represented by the product service */
export type Product = i.TypeOf<typeof Product>;

export const summary = (p: Product) =>
    S.create({ name: p.name, image: p.thumbnailUrl ?? 'http://via.placeholder.com/150' });
